<!-- 查询注册用户绑定车辆接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure.vue"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "parkCode": "2KKN1234",
            },
            responseCode: {
                "data": {
                "merchantCode":"131"
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台,查询车场微信支付到账商户号",
                t_url: this.commonUrls.test+"getParkMerchantInfo",
                p_url: this.commonUrls.prod+"getParkMerchantInfo",
                precondition: "无",
                fitSystem: "VEMS传统停车场，云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        ]
                },],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'merchantCode', info2: '是', info3: 'String', info4: '微信支付到账商户号' },
                        { info1: 'payPlatform', info2: '是', info3: 'Integer', info4: '支付平台：0微信官方,1支付宝官方,2通联支付,3全付通,4银联,5支付中间件' },
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/urbanOperation/ydtUser/getParkMerchantInfo.vue